import React from "react";
import "./ProgressModal.css";

/**
 * Small modal showing progress percent
 * Props:
 * - open: boolean
 * - percent: number 0-100
 * - pageIndex, total (optional)
 * - onCancel: optional
 */
export default function ProgressModal({ open, percent = 0, pageIndex = 0, total = 0, onCancel }) {
  if (!open) return null;
  return (
    <div className="pm-overlay" role="dialog" aria-modal="true">
      <div className="pm-modal">
        <h3>Preparing PDF…</h3>
        <div className="pm-progress">
          <div className="pm-bar" style={{ width: `${percent}%` }} />
        </div>
        <div className="pm-meta">
          <div>{percent}%</div>
          <div>{pageIndex > 0 ? `Page ${pageIndex} of ${total}` : ""}</div>
        </div>

        <div style={{ marginTop: 12 }}>
          {onCancel ? (
            <button className="btn-outline" onClick={onCancel}>Cancel</button>
          ) : null}
        </div>
      </div>
    </div>
  );
}